import { render } from "./FreeTradeSell.vue?vue&type=template&id=2e66d722&ts=true"
import script from "./FreeTradeSell.vue?vue&type=script&lang=ts"
export * from "./FreeTradeSell.vue?vue&type=script&lang=ts"

import "./FreeTradeSell.vue?vue&type=style&index=0&id=2e66d722&lang=scss"

import exportComponent from "D:\\Project\\wallet\\wallet-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__